import { memo } from 'react'
import cn from 'clsx'
import { motion, AnimatePresence } from 'framer-motion'
import { useDispatch } from 'react-redux'

// Components
import { IconLoopSmall } from '@tracklib/kit'

// Actions
import { actions as audioActions } from 'modules/audio/actions'

// Types
import { Loop } from 'types'

import styles from './loopbutton.css'

type LoopButtonProps = {
  loop: Loop | null | undefined
  isLoadingLoop: boolean
  isActive: boolean
  className?: string
  compact: boolean
  animated?: boolean
}

const LoopButton = ({ loop, isLoadingLoop, isActive, className, compact, animated }: LoopButtonProps): JSX.Element | null => {
  const dispatch = useDispatch()
  if (isLoadingLoop || isActive) {
    return (
      <AnimatePresence>
        <motion.span
          className={cn(
            loop || isLoadingLoop ? styles.loopButtonActive : styles.loopButton,
            isLoadingLoop && styles.loopButtonLoading,
            compact && styles.loopButtonCompact,
            className,
          )}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0 }}
          transition={{
            type: 'spring',
            stiffness: 400,
            mass: 1,
            damping: 16,
          }}
        >
          {animated && !isLoadingLoop && !loop && <span className={styles.pulse} />}
          <button onClick={() => dispatch(audioActions.toggleLoop())}>
            <IconLoopSmall />
          </button>
        </motion.span>
      </AnimatePresence>
    )
  }

  return null
}

export default memo(LoopButton)
